import {
  dateOfBirthUI,
  dateOfBirthSchema,
  fullNameSchema,
  titleUI,
  fullNameUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { UnauthenticatedWarningAlert } from '../../../components/FormAlerts';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['veteran-name-title']),
    'view:warningAlert': {
      'ui:description': UnauthenticatedWarningAlert,
    },
    veteranFullName: fullNameUI(),
    veteranDateOfBirth: dateOfBirthUI({
      monthSelect: false,
    }),
  },
  schema: {
    type: 'object',
    required: ['veteranFullName', 'veteranDateOfBirth'],
    properties: {
      'view:warningAlert': {
        type: 'object',
        properties: {},
      },
      veteranFullName: fullNameSchema,
      veteranDateOfBirth: dateOfBirthSchema,
    },
  },
};
